export const USER_API_CONSTANTS = {
  USER_PERSONAL_INFO: "userAccount/getPersonalInfo",
  CHECK_ACTIVE_SESSION: "auth/check_active_session",
};
